import { defineAction } from '~/prix'
import questionnaireListAction from './questionList.action.json' with { type: 'json' }
import { questionObject } from '../questionObject'
import { z } from 'zod'

const questionListDefinition = defineAction({
  ...questionnaireListAction,
  input: z.object({}),
  output: z.object({
    items: z.array(questionObject),
    count: z.number(),
  }),
})

export default questionListDefinition
